import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import EmptyCase, {emptyCaseDefaultSizes, emptyCaseDefaultTitleSizes} from '@adv-mt/mt-empty-case-default'

const EmptyCaseFavorites = ({section}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')

  const {FAVORITES_EMPTY_CASE_ASSET_PATH} = config.get('favorites')

  const isVehiclesSection = section === 'vehicles'

  const title = isVehiclesSection
    ? 'FAVORITE_PAGE.SECTIONS.FAVORITE_ADS.EMPTY_CASE_TITLE'
    : 'FAVORITE_PAGE.SECTIONS.FAVORITE_DEALERS.EMPTY_CASE_TITLE'
  const text = isVehiclesSection
    ? 'FAVORITE_PAGE.SECTIONS.FAVORITE_ADS.EMPTY_CASE_TEXT'
    : 'FAVORITE_PAGE.SECTIONS.FAVORITE_DEALERS.EMPTY_CASE_TEXT'

  const props = {
    imageUrl: `images/${FAVORITES_EMPTY_CASE_ASSET_PATH}`,
    title,
    text,
    titleSize: emptyCaseDefaultTitleSizes.xs,
    imageSize: emptyCaseDefaultSizes.MEDIUM,
    buttonText: 'FAVORITE_PAGE.EMPTY_CASE_BUTTON',
    buttonHref: '/search/'
  }
  return <EmptyCase {...props} />
}

EmptyCaseFavorites.displayName = 'EmptyCaseFavorites'
EmptyCaseFavorites.propTypes = {
  section: PropTypes.oneOf(['vehicles', 'dealers'])
}

export default EmptyCaseFavorites
